import { render, staticRenderFns } from "./ATenantGeneral.vue?vue&type=template&id=5138fd03&"
import script from "./ATenantGeneral.vue?vue&type=script&lang=js&"
export * from "./ATenantGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports